/**
 * Ansicht der Notendarstellung.
 *
 * Abonniert den Controller und erzeugt bei jeder Änderung eine frische
 * SVG-Notation aus dem aktuellen Pattern. Enthält selbst keine
 * fachliche Logik – die Umsetzung Pattern → Noten liegt im
 * Notationsmodul.
 */

import type { EditorController, EditorSnapshot } from '../app/EditorController';
import { renderScoreFor } from '../notation/renderSvg';

export class NotationView {
  readonly #controller: EditorController;
  #container: HTMLElement | null = null;
  #unsubscribe: (() => void) | null = null;

  constructor(controller: EditorController) {
    this.#controller = controller;
  }

  /** Bindet die Ansicht an einen Container und aktiviert sie. */
  mount(container: HTMLElement): void {
    this.#container = container;
    this.#unsubscribe = this.#controller.subscribe((snapshot) => {
      this.#render(snapshot);
    });
  }

  /** Löst Registrierungen. */
  destroy(): void {
    this.#unsubscribe?.();
    this.#unsubscribe = null;
    this.#container = null;
  }

  #render(snapshot: EditorSnapshot): void {
    if (!this.#container) {
      return;
    }
    const svg = renderScoreFor(snapshot.pattern, snapshot.meta);
    this.#container.replaceChildren(svg);
  }
}
